import React from 'react';
import ClientFollowupPage from './ClientFollowupPage';

const ReturnFollowup = () => (
  <ClientFollowupPage
    title="Return Followup"
    endpoint="ClientReturnClientFollowupList"
    parentKey="ClientReturn"
    amountLabel="Amount"
    amountKey=""
  />
);

export default ReturnFollowup;
